var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7644 1.97686C14.102 1.04287 12.0769 1.04287 10.4145 1.97686L4.25096 5.43974C2.76222 6.27617 2.76221 8.42795 4.25096 9.26437L10.4145 12.7273C12.0769 13.6612 14.102 13.6612 15.7644 12.7273L21.9279 9.26437C23.4167 8.42795 23.4167 6.27617 21.9279 5.43974L15.7644 1.97686Z",
    fill: "#6FBE45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87482 15.6592C2.77505 16.6189 2.90042 18.4602 4.25096 19.2189L10.4145 22.6818C12.0769 23.6158 14.102 23.6158 15.7644 22.6818L21.9279 19.2189C23.2785 18.4602 23.4038 16.6189 22.3041 15.6592L16.5145 18.9119C14.3863 20.1077 11.7926 20.1076 9.66435 18.9119L3.87482 15.6592Z",
    fill: "#6FBE45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7084 10.7158C2.79202 11.7082 2.97287 13.3958 4.25096 14.1138L10.4145 17.5767C12.0769 18.5107 14.102 18.5107 15.7644 17.5767L21.9279 14.1138C23.206 13.3958 23.3869 11.7082 22.4705 10.7158L16.5145 14.0621C14.3863 15.2578 11.7926 15.2578 9.66435 14.0621L3.7084 10.7158Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcpl);
export default __webpack_public_path__ + "static/media/bcpl.cc4c8d746f62719f5727eb8c0bf982c7.svg";
export { ForwardRef as ReactComponent };